import { isAfter, isBefore, isValid, parse, startOfDay } from 'date-fns';

export const EVENT_START_TIME_MIN = '05:00';
export const EVENT_START_TIME_MAX = '21:00';
export const EVENT_END_TIME_MAX = '23:59';

export function isStartTimeWithinAllowedWindow(startTimeHhMm: string, startDate: Date): boolean {
  const day = startOfDay(startDate);
  const t = parse(startTimeHhMm, 'HH:mm', day);
  const minT = parse(EVENT_START_TIME_MIN, 'HH:mm', day);
  const maxT = parse(EVENT_START_TIME_MAX, 'HH:mm', day);
  if (!isValid(t) || !isValid(minT) || !isValid(maxT)) {
    return false;
  }
  return !isBefore(t, minT) && !isAfter(t, maxT);
}
